import type { Client } from "@opensea/graphql"
import { prefetchCollectionPageLayout } from "@/components/collection/CollectionPageLayout/query"
import { prefetchCollectionItemsActionBarQuery } from "@/components/items/collection/CollectionItemsActionBar/query"
import { prefetchCollectionItemsCountQuery } from "@/components/items/collection/CollectionItemsCountProvider/query"
import { prefetchCollectionItemsListQuery } from "@/components/items/collection/CollectionItemsList/query"

export function prefetchCollectionItemsPage(
  collectionSlug: string,
  client: Client,
) {
  prefetchCollectionItemsListQuery(collectionSlug, client)
  prefetchCollectionItemsActionBarQuery(collectionSlug, client)
  prefetchCollectionItemsCountQuery(collectionSlug, client)
  prefetchCollectionPageLayout(collectionSlug, client)
}
